import Text from '~/components/Text';
import { useClientListContext } from '../hooks/useClientListContext';
import { fmPrice } from '~/utils/amount';
import ClientContextMenu from './ClientContextMenu';

interface ICellContentProps {
  clientReferenceId: string;
  identifier: string;
  handleOpenClient(clientReferenceNumber: string): void;
}

const defaultValueDash = '--';

const CellContent = ({ clientReferenceId, identifier }: ICellContentProps) => {
  const { listData } = useClientListContext();
  const thisClientData = listData[clientReferenceId];

  if (typeof thisClientData === 'undefined') {
    return null;
  }

  if (identifier === 'client_name') {
    return <Text className="bold">{thisClientData.company_name}</Text>;
  }

  if (identifier === 'email') {
    return <Text>{thisClientData[identifier]}</Text>;
  }

  if (identifier === 'phone') {
    if (!thisClientData.phone) {
      return <Text>{defaultValueDash}</Text>;
    }

    const countryCode = thisClientData.country_code
      ? thisClientData.country_code.split(' ')[0]
      : '';

    return (
      <Text>
        {countryCode} {thisClientData.phone}
      </Text>
    );
  }

  if (identifier === 'total_billed') {
    return <Text>{fmPrice(thisClientData.currency, thisClientData.total_billed)}</Text>;
  }

  if (identifier === 'actions') {
    return (
      <div className="center">
        <ClientContextMenu clientReferenceId={clientReferenceId} />
      </div>
    );
  }

  return <p data-text-type="main-text">{defaultValueDash}</p>;
};

export default CellContent;
